module.exports = __webpack_public_path__ + "img/slide1.862476d6.png";